module.exports = __webpack_public_path__ + "static/muscle_movement-3bf7ad9af2c9cfa63cdd2c5863b50031.jpg";